<section class="main-sec" id = "main-outer" [ngStyle]="{'font-family': GlobalConstants?.data?.font_family.name}" [attr.data-client]="GlobalConstants.client">
  <router-outlet></router-outlet>
</section>
<app-footer></app-footer>
